import React from 'react'

export const UserManagementIcon = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.39434 10.1387C8.85367 10.1387 10.9557 10.5113 10.9557 12C10.9557 13.4887 8.86767 13.872 6.39434 13.872C3.93434 13.872 1.83301 13.5027 1.83301 12.0133C1.83301 10.524 3.92034 10.1387 6.39434 10.1387Z"
        stroke="#004360"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.3947 8.01366C4.78004 8.01366 3.4707 6.70499 3.4707 5.09033C3.4707 3.47566 4.78004 2.16699 6.3947 2.16699C8.0087 2.16699 9.31804 3.47566 9.31804 5.09033C9.32404 6.69899 8.02404 8.00766 6.41537 8.01366H6.3947Z"
        stroke="#004360"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.9883 7.25451C12.0556 7.10451 12.8776 6.18851 12.8796 5.07985C12.8796 3.98718 12.0829 3.08051 11.0383 2.90918"
        stroke="#004360"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3965 9.82227C13.4305 9.97627 14.1525 10.3389 14.1525 11.0856C14.1525 11.5996 13.8125 11.9329 13.2632 12.1416"
        stroke="#004360"
        stroke-width="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
